"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Calendar = function Calendar(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M9.503 5.132v1.875a.625.625 0 11-1.25 0V5.132a.625.625 0 111.25 0zm9.375 1.875v10.625c0 .69-.56 1.25-1.25 1.25H6.378c-.69 0-1.25-.56-1.25-1.25V7.007c0-.69.56-1.25 1.25-1.25h.938c.172 0 .312.14.312.312v.884A1.286 1.286 0 008.755 8.25a1.25 1.25 0 001.373-1.244v-.938c0-.173.14-.313.313-.313h3.125c.172 0 .312.14.312.313v.884a1.286 1.286 0 001.127 1.298 1.25 1.25 0 001.373-1.244v-.938c0-.173.14-.313.313-.313h.937c.69 0 1.25.56 1.25 1.25zm-1.562 3.75H6.69a.313.313 0 00-.313.312v6.25c0 .173.14.313.313.313h10.625c.172 0 .312-.14.312-.313v-6.25a.313.313 0 00-.312-.313zm-2.188-6.25c.345 0 .625.28.625.625v1.875a.625.625 0 11-1.25 0V5.132a.625.625 0 01.625-.625z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Calendar);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Calendar, "Calendar", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Calendar.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Calendar.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DYWxlbmRhci50c3giXSwibmFtZXMiOlsiQ2FsZW5kYXIiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBd0UsR0FBRyxTQUEzRUEsUUFBMkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDL0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsQ0FBQyxFQUFDLG9wQkFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQrRTtBQUFBLENBQWpGOztlQVNlLHVCQUFXRixRQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLFEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENhbGVuZGFyOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PFNWR1NWR0VsZW1lbnQsIFNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcywgcmVmKSA9PiAoXG4gIDxzdmcgd2lkdGg9ezI0fSBoZWlnaHQ9ezI0fSB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfSByZWY9e3JlZn0+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNOS41MDMgNS4xMzJ2MS44NzVhLjYyNS42MjUgMCAxMS0xLjI1IDBWNS4xMzJhLjYyNS42MjUgMCAxMTEuMjUgMHptOS4zNzUgMS44NzV2MTAuNjI1YzAgLjY5LS41NiAxLjI1LTEuMjUgMS4yNUg2LjM3OGMtLjY5IDAtMS4yNS0uNTYtMS4yNS0xLjI1VjcuMDA3YzAtLjY5LjU2LTEuMjUgMS4yNS0xLjI1aC45MzhjLjE3MiAwIC4zMTIuMTQuMzEyLjMxMnYuODg0QTEuMjg2IDEuMjg2IDAgMDA4Ljc1NSA4LjI1YTEuMjUgMS4yNSAwIDAwMS4zNzMtMS4yNDR2LS45MzhjMC0uMTczLjE0LS4zMTMuMzEzLS4zMTNoMy4xMjVjLjE3MiAwIC4zMTIuMTQuMzEyLjMxM3YuODg0YTEuMjg2IDEuMjg2IDAgMDAxLjEyNyAxLjI5OCAxLjI1IDEuMjUgMCAwMDEuMzczLTEuMjQ0di0uOTM4YzAtLjE3My4xNC0uMzEzLjMxMy0uMzEzaC45MzdjLjY5IDAgMS4yNS41NiAxLjI1IDEuMjV6bS0xLjU2MiAzLjc1SDYuNjlhLjMxMy4zMTMgMCAwMC0uMzEzLjMxMnY2LjI1YzAgLjE3My4xNC4zMTMuMzEzLjMxM2gxMC42MjVjLjE3MiAwIC4zMTItLjE0LjMxMi0uMzEzdi02LjI1YS4zMTMuMzEzIDAgMDAtLjMxMi0uMzEzem0tMi4xODgtNi4yNWMuMzQ1IDAgLjYyNS4yOC42MjUuNjI1djEuODc1YS42MjUuNjI1IDAgMTEtMS4yNSAwVjUuMTMyYS42MjUuNjI1IDAgMDEuNjI1LS42MjV6XCJcbiAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihDYWxlbmRhcik7XG4iXX0=